// Build-time constants - require application rebuild to change
export const CENCERT_LOGO_URL = '/logo.png'
export const ADDITIONAL_LOGO_URL = '/autenti.svg'

export const DEFAULT_LANGUAGE = 'pl'

// Layout Constants
export const HEADER_HEIGHT = 76
export const HEADER_HEIGHT_PX = '76px'
export const MOBILE_ACCORDION_HEIGHT_PX = '80px'

// Mobile App Integration
export const MOBYWATEL_DEEPLINK = 'mobywatel://identity/confirm'
export const MOBYWATEL_APP_NAME = 'mobywatel'
